module.exports = __webpack_public_path__ + "static/media/group_trainings_arms_outstretched_somatic_exercise.0e3b9eff.webp";